import ColorTile from './ColorTile'
export * from './MobileColorTile'
export type { ColorTileProps } from './ColorTile'
export default ColorTile
